import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, NavLink } from 'react-router-dom';
import './App.css';
import LandingPage from './LandingPage';
import ProjectionsPage from './ProjectionsPage';
import DFSPage from './DFSPage';
import logo from './assets/logo.png';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation */}
        <nav className="main-nav">
          <Link to="/" className="nav-logo">
            <img src={logo} alt="LapLeaders" className="nav-logo-img" />
          </Link>
          <div className="nav-links">
            <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
            <NavLink to="/projections" className={({ isActive }) => isActive ? 'active' : ''}>Projections</NavLink>
            <NavLink to="/dfs" className={({ isActive }) => isActive ? 'active' : ''}>DFS Optimizer</NavLink>
          </div>
        </nav>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/projections" element={<ProjectionsPage />} />
          <Route path="/dfs" element={<DFSPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
